export default __webpack_public_path__ + "static/media/back.25bd8e9e.png";